import '../components'

import createDecisionEvent, { NAME as DECISION_EVENT_NAME, ConsentDecision, ConsentDecisionEvent } from './consent-decision-event'
import { NAME as DIALOG_CLOSE_EVENT_NAME } from './dialog-close-event'
import { NAME as OPEN_PANEL_EVENT_NAME } from './open-panel-event'
import { NAME as CLOSE_PANEL_EVENT_NAME } from './close-panel-event'
import { NAME as COOKIE_BOT_OPEN_EVENT_NAME } from './cookie-bot-open'
import { NAME as LOGIN_EVENT_NAME } from './login-event'
import createLoadedEvent from './loaded-event'
import createOpenEvent from './open-event'
import createAuthEvent from './auth-event'
import { Destructor, createElementDestructor, createDestructor } from './destructor'
import { API_ORIGIN, API_PATH } from '../config'


export interface ConsentizerOptions {
    appId: string
    template?: string
    apiUrl?: string
    ns?: string
}

export type DecisionEnum = 'reject' | 'mixed' | 'allow'

export interface Bubble {
    code: string,
    text: string,
    ctaText?: string
    ctaLink?: string
}
export interface ConsentizerInitArgs {
    url: string,
    decision: DecisionEnum,
    bubble?: Bubble,
    alert?: Bubble,
    meetWaulter?: boolean,
    color?: "purple" | "yellow",
    cb?: boolean,
    userInitials?: string,
    iconStyle?: 'warning' | 'error' | 'info',
    webDetail?: WebDetail
}

export interface WebDetailPartner {
    logo: string,
    background: string,
    name: string,
    description: string
}

export interface UserPreferenceRating {
    code: string,
    userPreferenceTypeEnum: string,
    description: string
}

export interface WebDetail {
    url:string,
    score: string,
    scoreValue: number,
    partner: WebDetailPartner,
    linkCookies: string,
    linkPrivacy: string,
    userPreferenceRatings?: Array<UserPreferenceRating>,
    nextMessage?: UserMessage

}

export interface UserMessage {
    bubble?: Bubble,
    alert?: Bubble,
    meetWaulter?: Boolean
}

export interface Message {
    code:string,
    bubble?: Bubble,
    alert?: Bubble
}

export default class ControlPanel {
    constructor(apiUrl: string) {
        this._apiUrl = apiUrl;
        this._handleOpenPanel = this._handleOpenPanel.bind(this)
        this._handleClosePanel = this._handleClosePanel.bind(this)
        this._handleCookieBotOpen = this._handleCookieBotOpen.bind(this)
        this._handleLogin = this._handleLogin.bind(this)
        this._handleLoginCallback = this._handleLoginCallback.bind(this)
    }

    private _apiUrl = '';
    private _appId = 'abc456';
    private _userId ='';
    private _url: string = ''
    private _cb: boolean = false
    private _localMode: boolean = false
    private _bubble?: Bubble
    private _alert?: Bubble
    private _meetWaulter: boolean = false
    private _consentizerId!: string | null
    private _decision?: ConsentDecision | null | undefined
    private _template?: string | null
    private _popupElement: Destructor | null = null
    private _initialized: boolean = false
    private _useGtm: boolean = false
    private _loginWindow: Destructor | null = null
    private _webDetail: WebDetail | null = null
    private _userInitials: string = ''
    private _iconStyle: 'warning' | 'error' | 'info' = 'info'



   
    private _handleOpenPanel(event: MessageEvent) {
        this._OpenPanel()

    }

    private _handleClosePanel(event: MessageEvent)
    {
        this._ClosePanel()
    }

    private _handleCookieBotOpen(event: MessageEvent)
    {
        this._OpenCookieBot()
    }

    private _handleLogin(event: CustomEvent) {
        if (this._loginWindow) {
            this._loginWindow()
            this._loginWindow = null
        }

        const box = {
            width: 460,
            height: 600,
            left: 0,
            top: 0
        }

        if (box.height > window.screen.height) {
            box.height = window.screen.height
        }

        if (box.width > window.screen.width) {
            box.width = window.screen.width
            box.height = window.screen.height
        }

        box.left = (window.screen.width - box.width) / 2
        box.top = (window.screen.height - box.height) / 2

        const handle = window.open(
            `${API_ORIGIN}/${API_PATH}/login?appId=${this._appId}`,
            ``,
            `popup,width=${box.width},height=${box.height},left=${box.left},top=${box.top}`
        )

        if (handle) {
            this._loginWindow = createDestructor(handle, x => x.close())
        }
    }

    private _handleLoginCallback(event: MessageEvent) {
        if (event.origin !== API_ORIGIN) {
            return
        }

        if (event.data.type !== 'auth') {
            return
        }

        this._userId = event.data.userId

        //window.dispatchEvent(createAuthEvent())

        if (event.data.decision || event.data.userInitials) {
            this._decision = event.data.decision

            //this._notAfter = new Date(event.data.notAfter)
            //this._closePrompt()
            console.log("initializing")
            this.init({url: this._url, decision: event.data.decision, userInitials: event.data.userInitials })
            //this._dispatchDecisionEvent()
        }

        const sourceWindow: WindowProxy = event.source as any
        if (sourceWindow.close) {
            sourceWindow.close()
        }
    }

    private _dispatchDecisionEvent() {
        const decision = this._decision || 'reject'

        window.dispatchEvent(createDecisionEvent(decision))

        if (this._useGtm) {
            window.dataLayer.push({
                'event': 'Consentizer:Decision',
                'Consentizer:Decision': decision
            })
        }
    }

    private _dispatchLoadedEvent() {
        window.dispatchEvent(createLoadedEvent())

        if (this._useGtm) {
            window.dataLayer.push({
                'event': 'Consentizer:Loaded',
            })
        }
    }

    private _dispatchOpenEvent() {

        window.dispatchEvent(createOpenEvent())

        if (this._useGtm) {
            window.dataLayer.push({
                'event': 'Consentizer:Open',
            })
        }
    }

    private _OpenPanel()
    {
        console.log("opening panel")
        const detSett = window.document.getElementById('WLTR_popup');
        if (detSett != null)
            detSett.style.display = 'block';
        //const mainWind = window.document.getElementById('WLTR_mainScreen');
        //if (mainWind != null)
        //    mainWind.style.display = 'none';
        if (this._localMode)
        {
            window.postMessage({
                type: 'cp:opendialog'
            }, '*');
            console.debug("Message cp:opendialog sended.");
        }
        else
            this._reportCPdisplay()
    }

    private _ClosePanel()
    {
        console.log("closing panel")
        const detSett = window.document.getElementById('WLTR_popup');
        if (detSett != null)
            detSett.style.display = 'none';
        //const mainWind = window.document.getElementById('WLTR_mainScreen');
        //if (mainWind != null)
        //    mainWind.style.display = 'none';
    }

    private _OpenCookieBot()
    {
        console.log("open cookie bot")

        this._ClosePanel();


        window.postMessage({
            type: 'cb:opendialog'
        }, '*');
    }


    // async/await increases bundle size by 7 KiB; it is better to avoid that
     public async init(opt: ConsentizerInitArgs) {

        if (this._initialized)
        {
            //CP EXIST
            console.log("CP exists")
            console.log(opt)
            const detSett = window.document.getElementsByTagName('cp-control-panel')[0] as HTMLElement;
            if (detSett !== undefined)
            {
                if (opt.decision !== undefined)
                    detSett.setAttribute('decision', opt.decision);
                if (opt.userInitials !== undefined && opt.userInitials !== null)
                    detSett.setAttribute('userInitials', opt.userInitials);
                if (opt.meetWaulter !== undefined)
                    if (opt.meetWaulter)
                        detSett.setAttribute('meetWaulter', 'true');
                    else
                        detSett.setAttribute('meetWaulter', 'false');
            }          


            if (opt.bubble !== undefined)
            {
                if (opt.bubble.code !== undefined) 
                    this._bubble = (await this._loadMessage(opt.bubble.code)).bubble;
                else
                    this._bubble = opt.bubble;
                if (this._bubble !== undefined)
                {
                    bubblehtml = `<cp-bubble id='WLTR_infoBubble' text='${ this._bubble.text}' ${ this.getKV("ctaText", this._bubble.ctaText) } ${ this.getKV("ctaLink",this._bubble.ctaLink) }></cp-bubble>`;

                    const detIcon = window.document.getElementsByTagName('cp-control-icon')[0] as HTMLElement;
                    if (detIcon !== undefined)
                        detIcon.innerHTML = bubblehtml;
                }    
            }
            console.log(this._alert)
            if (opt.alert !== undefined && this._alert === undefined)
            {
                if (opt.alert.code !== undefined) 
                    this._alert = (await this._loadMessage(opt.alert.code)).alert;
                else
                    this._alert = opt.alert;
                if (this._alert !== undefined)
                {
                    const panelEl = window.document.getElementsByTagName('cp-control-panel')[0] as HTMLElement;
                    if (panelEl !== undefined)
                    {
                        console.log(this._alert.text)
                        panelEl.setAttribute('alertText', this._alert.text);
                        if (this._alert.ctaText !== undefined) panelEl.setAttribute('alertCtaText', this._alert.ctaText);
                        if (this._alert.ctaLink !== undefined) panelEl.setAttribute('alertCtaLink', this._alert.ctaLink);
                    }
                }

            }
        }
        else
        {
            //CP INIT NEW
            this._decision = opt.decision;
            this._bubble = opt.bubble;
            this._alert = opt.alert;

            if (opt.cb !== undefined)
                this._cb = opt.cb;
            if (opt.userInitials !== undefined && opt.userInitials !== null)     
                this._userInitials = opt.userInitials;
            if (opt.iconStyle !== undefined)
                this._iconStyle = opt.iconStyle;
            if (opt.meetWaulter !== undefined)
                this._meetWaulter = opt.meetWaulter;

            if (opt.url === undefined || opt.url === null || opt.url === '')
            {
                this._url = window.location.hostname.replace('www.','');
                console.debug("cp hostname:"+this._url);
            }
            else
                this._url = opt.url;

            if (opt.webDetail === undefined)
                this._webDetail = await this._loadWebDetail(this._url);
            else
            {
                this._webDetail = opt.webDetail;
                this._localMode = true;
            }
            
            if (this._webDetail == null)
            {
                throw new Error('Problem with fetching web detail data.');
            }
            if (this._webDetail.scoreValue === undefined) this._webDetail.scoreValue = 0;   
            //if exist nextMessage.bubble in webDetail call, use it
            if (this._bubble === undefined && this._webDetail.nextMessage !== undefined && this._webDetail.nextMessage.bubble !== undefined)
                this._bubble = this._webDetail.nextMessage.bubble;
            //if exist nextMessage.alert in webDetail call, use it
            if (this._alert === undefined && this._webDetail.nextMessage !== undefined && this._webDetail.nextMessage.alert !== undefined)
                this._alert = this._webDetail.nextMessage.alert;
            //if exist nextMessage.meeWaulter in webDetail call, use it
            if (this._webDetail.nextMessage !== undefined && this._webDetail.nextMessage.meetWaulter === true)
                this._meetWaulter = true;


            var bubblehtml = '';
            if (this._bubble !== undefined)
            {
                if (this._bubble.code !== undefined) 
                    this._bubble = (await this._loadMessage(this._bubble.code)).bubble;
                if (this._bubble !== undefined)
                    bubblehtml = `<cp-bubble id='WLTR_infoBubble'  text='${ this._bubble.text}' ${ this.getKV("ctaText", this._bubble.ctaText) } ${ this.getKV("ctaLink",this._bubble.ctaLink) }></cp-bubble>`;
            }
                

            var alertText = '';
            if (this._alert !== undefined)
            {
                if (this._alert.code !== undefined) 
                    this._alert = (await this._loadMessage(this._alert.code)).alert;
                if (this._alert !== undefined)
                    alertText = `${ this.getKV("alertText", this._alert.text) } ${ this.getKV("alertCtaText", this._alert.ctaText) } ${ this.getKV("alertCtaLink", this._alert.ctaLink) }`;
            }

            var partnerHtml = '';
            if (this._webDetail.partner !== undefined)
            {  
                var userPreferenceRatingsHtml = ''
                if (this._webDetail.userPreferenceRatings !== undefined)
                    userPreferenceRatingsHtml = this._webDetail.userPreferenceRatings.map(obj => obj.description).join(" ");
                partnerHtml = `logo='${this._webDetail.partner.logo}' ${this.getKV("background",this._webDetail.partner.background)} ${this.getKV("name",this._webDetail.partner.name)}  ${this.getKV("userPreferenceRatings",userPreferenceRatingsHtml)}`
            }

            if (this._webDetail != undefined)
                this._template = "<cp-template><cp-control-icon "+(this._webDetail.partner !== undefined ? "partner":"")+" " + (this._iconStyle === 'warning' ? "warning":(this._iconStyle === 'error'?"error":""))+ ">"+bubblehtml+"</cp-control-icon><cp-control-panel id='WLTR_popup' " + (this._cb ? "cb=true":"") +"  url='" + this._url +"' decision='" + this._decision + "' userInitials='" + this._userInitials + "' scoreValue='" + this._webDetail.scoreValue.toString() + "' " + this.getKV("linkCookies", this._webDetail.linkCookies) + " " + this.getKV("linkPrivacy", this._webDetail.linkPrivacy) + " " + (this._webDetail.partner !== undefined ? "partner=true " + partnerHtml:"")+" meetWaulter='"+ this._meetWaulter +"' " + alertText + "></cp-control-panel></cp-template>";

            console.log("template:" + this._template)

            window.addEventListener(OPEN_PANEL_EVENT_NAME, this._handleOpenPanel as any)
            window.addEventListener(CLOSE_PANEL_EVENT_NAME, this._handleClosePanel as any)
            window.addEventListener(COOKIE_BOT_OPEN_EVENT_NAME, this._handleCookieBotOpen as any)
            window.addEventListener(LOGIN_EVENT_NAME, this._handleLogin as any)
            window.addEventListener('message', this._handleLoginCallback)

            this._dispatchLoadedEvent()

            this.showControlPanel(document.body)
                .catch(() => {})
            this._initialized = true;
        }
    }

    public showControlPanel(target: HTMLElement) {
        return new Promise<ConsentDecision>((resolve, reject) => {
            if (!this._template) {
                reject()
                return
            }

            const template = document.createElement('template')
            template.innerHTML = this._template

            let child: Element | null

            const fragment = template.content.cloneNode(true)
            if (fragment instanceof DocumentFragment) {
                child = fragment.firstElementChild
            }
            else {
                child = fragment as Element
            }

            if (child) {
                const closeHandler = () => {
                    //this.reject()
                }
                child.addEventListener(DIALOG_CLOSE_EVENT_NAME, closeHandler)

                target.appendChild(child)
                this._popupElement = createElementDestructor(target, child, elm => elm.removeEventListener(DIALOG_CLOSE_EVENT_NAME, closeHandler))
                //this._dispatchOpenEvent()
            }
            else {
                reject()
            }

        })
        .finally(() => {
        })
    }

    tearDown() {

        window.removeEventListener(OPEN_PANEL_EVENT_NAME, this._handleOpenPanel as any)
        window.removeEventListener(CLOSE_PANEL_EVENT_NAME, this._handleClosePanel as any)
        window.removeEventListener(COOKIE_BOT_OPEN_EVENT_NAME, this._handleCookieBotOpen as any)

    }

    private async _loadWebDetail(url: string): Promise<WebDetail | null> {

        const requestUrl = `${this._apiUrl}/detail?source=SDK&url=${url}`

        const options: RequestInit = {
            method: 'get',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            }
        }
        try {
        const response = await fetch(requestUrl, options);

        if (!response.ok) {
            throw new Error('Failed to fetch data');
          }
          const data: WebDetail = await response.json();
          return data;

        } catch (error:any) {
          console.error('Error fetching data:', error);
          return null;
    }}

    private async _loadMessage(code: string): Promise<Message> {

        const requestUrl = `${this._apiUrl}/message?code=${code}`

        const options: RequestInit = {
            method: 'get',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            }
        }

        const response = await fetch(requestUrl, options);

        if (!response.ok) {
            throw new Error('Failed to fetch data');
          }
          const data: Message = await response.json();
          return data;

    } 

    private async _reportCPdisplay() {
        const requestUrl = `${this._apiUrl}/report?appId=${this._appId}&nonce=${Date.now()}`

        const options: RequestInit = {
            method: 'post',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                type: 'cp_display',
                url: window.location.href
            })
        }

        return fetch(requestUrl, options)
            .then(res => {
                if (!res.ok) {
                    throw res
                }
            })
            .catch(err => {
                if (process.env.NODE_ENV !== 'production') {
                    // just during development
                    console.warn(err)
                }

                // silently do nothing, user does not want to see errors in the console
            })
    }


    private getKV(key: string, value: any): string {
        if (value === undefined)
            return "";
        else
            return `${key}='${value}'`
      }
}
